export default {
	//基础配置-店铺权限-新增-编辑
	summarySupplement: {
		url: '/ec-pc-api/smallPieces/manage/storeUser/saveOrUpdate',
		type: 'post'
	},
	//基础配置-店铺权限-删除
	storeUserDel: {
		url: '/ec-pc-api/smallPieces/manage/storeUser/del',
		type: 'get'
	},
	//基础配置-提报店铺-编辑
	reportUpdate: {
		url: '/ec-pc-api/smallPieces/manage/store/report/update',
		type: 'post'
	},
	//店铺年度各月提报状态列表
	reportStatusList: {
		url: '/ec-pc-api/smallPieces/manage/store/reportStatusList',
		type: 'post'
	},
	//店铺可提报开关状态获取
	switchGet: {
		url: '/ec-pc-api/smallPieces/manage/reportAble/switch/get',
		type: 'get'
	},
	//全平台权限人员调整店铺可提报开关
	switchModify: {
		url: '/ec-pc-api/smallPieces/manage/reportAble/switch/modify',
		type: 'get'
	},
	//全平台-产品-新增
	productAdd: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/add',
		type: 'post'
	},
	//全平台-产品-编辑
	productUpdate: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/update',
		type: 'post'
	},
	//查询店铺某月提报状态
	storeReportStatus: {
		url: '/ec-pc-api/smallPieces/manage/storeReportStatus',
		type: 'get'
	},
	//全平台查询店铺某月提报状态汇总
	storeReportStatusSum: {
		url: '/ec-pc-api/smallPieces/manage/storeReportStatusSum',
		type: 'get'
	},
	//店铺(提交)
	submitProductInfo: {
		url: '/ec-pc-api/smallPieces/manage/submitProductInfo',
		type: 'post'
	},
	//全平台提报前分页
	allPlatProductSearch: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/search',
		type: 'post'
	},
	//用户店铺权限下拉列表受时间控制
	userStoreList: {
		url: '/ec-pc-api/smallPieces/manage/userStoreList',
		type: 'get'
	},
	//店铺提报前分页
	storeProductSearch: {
		url: '/ec-pc-api/smallPieces/manage/store/product/search',
		type: 'post'
	},
	//店铺提报前提报量编辑
	updateReportNum: {
		url: '/ec-pc-api/smallPieces/manage/store/product/updateReportNum',
		type: 'post'
	},
	//店铺-无需求操作接口
	storeNoDemand: {
		url: '/ec-pc-api/smallPieces/manage/store/noDemand',
		type: 'post'
	},
	//店铺提报前-导入历史查询
	importHistory: {
		url: '/ec-pc-api/customize/import/history',
		type: 'post'
	},
	//店铺提报前-导入店铺产品信息
	storeProductInfo: {
		url: '/ec-pc-api/customize/import/smallPieces/store/productInfo',
		type: 'post'
	},
	//全平台产品动态分页[提报前]-导出
	beforeAllPlatExport: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/export',
		type: 'post'
	},
	//店铺产品动态分页[提报前]-导出
	beforteStoreExport: {
		url: '/ec-pc-api/smallPieces/manage/store/product/export',
		type: 'post'
	},
	//全平台产品动态分页[提报后]-导出
	afterAllPlatExport: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/submited/export',
		type: 'post'
	},
	//店铺产品动态分页[提报后]-导出
	afterStoreExport: {
		url: '/ec-pc-api/smallPieces/manage/store/product/submited/export',
		type: 'post'
	},
	//全平台产品动态分页[提报后]
	afterAllPlatSearch: {
		url: '/ec-pc-api/smallPieces/manage/allPlat/product/submited/search',
		type: 'post'
	},
	//店铺产品动态分页[提报后]
	afterStoreSearch: {
		url: '/ec-pc-api/smallPieces/manage/store/product/submited/search',
		type: 'post'
	},
	//店铺-产品-仍需数量编辑
	updateStillNeedNum: {
		url: '/ec-pc-api/smallPieces/manage/store/product/updateStillNeedNum',
		type: 'post'
	},
	//小件跟进-下架
	operationShelfRemove: {
		url: '/ec-pc-api/smallPieces/manage/operation/shelfRemove',
		type: 'post'
	},
	//小件跟进-停销
	operationStopSale: {
		url: '/ec-pc-api/smallPieces/manage/operation/stopSale',
		type: 'post'
	},
	//小件跟进表动态分页
	trackInfoSearch: {
		url: '/ec-pc-api/smallPieces/manage/trackInfo/search',
		type: 'post'
	},
	//小件跟进表-动态分页导出
	trackInfoExport: {
		url: '/ec-pc-api/smallPieces/manage/trackInfo/export',
		type: 'post'
	},
	//按月查询店铺完成情况列表
	trackInfoStoreInfo: {
		url: '/ec-pc-api/smallPieces/manage/trackInfo/storeInfo',
		type: 'post'
	},
}